export default "__VITE_ASSET__D8HD5S$G__"